export const CreateAction = (type: any) =>
{
    return (data: any) => ({ type: type, payload: data });
}